/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SecretManagerAccount } from './secretManagerAccount';


export interface ResourceSecretManagerCredentialsUpsertSpec { 
    grouping_key?: string;
    secret_manager_account: SecretManagerAccount;
    secret_manager_path: string;
    secret_manager_refresh_time?: Date;
}
export namespace ResourceSecretManagerCredentialsUpsertSpec {
}


